import React from 'react';
import classNames, { Argument } from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'hooks';

import { arePreApprovedPricesHidden } from 'modules/selfServices/selectors';
import { usePriceFormatter } from 'utils/PriceFormatter/usePriceFormatter';

type TotalLineProps = {
  title: React.ReactNode,
  price: number,
  showHiddenPriceWarning?: boolean,
  className?: Argument
};

const TotalLine: React.FC<TotalLineProps> = (
  { title, price, showHiddenPriceWarning, className },
) => {
  const hidePreApprovedWorksPrices = useSelector(arePreApprovedPricesHidden);
  const priceFormatter = usePriceFormatter();

  const showWarning = showHiddenPriceWarning && hidePreApprovedWorksPrices;

  return (
    <div className={classNames('flex justify-between items-center text-lowest text-xs font-medium pl-2', className)}>
      <div>{title}</div>
      {showWarning && <FormattedMessage id="basket.total.toBeConfirmed" defaultMessage="To be confirmed" />}
      {!showWarning &&  priceFormatter(price)}
    </div>
  );
};

export default TotalLine;
